/* R-MC booking-, tilmeldings- og proeveturdialog.

   Dialogen er sin egen sektion og viser intet af sig selv. Den aabnes af
   enhver knap eller link paa siden, der peger paa dens anker — fx
   href="#tilmeld-gruskursus" eller data-rmc-bk-open="book-proevetur".
   Derfor virker den ogsaa med temaets EGNE sektioner og med raa HTML i sidens
   indhold, uden at de skal aendres.

   Klik fanges med delegering paa document, saa knapper der dukker op senere
   ogsaa virker.

   Scriptet goer seks ting:
   - folder en opgaves underpunkter ud, naar opgaven vinges af, og rydder dem
     igen naar den fravaelges (ellers ville skjulte valg blive sendt med)
   - holder valg i samme gruppe gensidigt udelukkende
   - blokerer afsendelse, hvis dialogen kraever mindst ét valg og der ikke er
     vinget noget af
   - advarer paa en proevetur, hvis der vaelges en dag hvor vi har lukket, og
     viser kun de tidspunkter der gaelder for den valgte ugedag
   - saetter emnefeltet til "<praefiks> - <deltagerens navn>" lige inden
     afsendelse
   - husker HVILKEN dialog der blev sendt, saa kun DEN viser kvitteringen
     bagefter. Shopify saetter form.posted_successfully? paa ALLE
     kontaktformularer paa siden, og eventsiden har én pr. event. Uden det her
     ville alle otte kvitteringer blive vist og alle otte dialoger aabne.

   Selve afsendelsen er Shopifys egen kontaktformular — ingen JS involveret.
   Alle felter har rigtige name-attributter, saa de sendes korrekt ogsaa hvis
   dette script skulle fejle. Kun valideringen og lukkedagsadvarslen gaar tabt. */
(function () {
  var dialoger = [];
  var NOEGLE = 'rmc-bk-sidst';
  var kvitteringVist = false;

  function aabn(dialog) {
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function underliste(box) {
    var punkt = box.closest('.rmc-bk-punkt');
    return punkt ? punkt.querySelector('.rmc-bk-under') : null;
  }

  function opdaterUnder(box) {
    var liste = underliste(box);
    if (!liste) return;
    liste.hidden = !box.checked;
    if (!box.checked) {
      liste.querySelectorAll('input[type="checkbox"]').forEach(function (c) {
        c.checked = false;
      });
    }
  }

  function harValg(dialog) {
    var valgt = dialog.querySelector('.rmc-bk-opgave > input[type="checkbox"]:checked');
    return !!valgt;
  }

  /* Proevetur: naar datoen skifter, tjekkes ugedagen mod aabningstiderne.
     Lukkedagene kommer fra sektionens indstillinger og staar som attributter
     paa dialogen. En lukkedag BLOKERER ikke afsendelsen - kunden maa gerne
     spoerge alligevel - men han faar det at vide med det samme. */
  function datoStyring(dialog) {
    var dato = dialog.querySelector('[data-rmc-dato]');
    var tid = dialog.querySelector('[data-rmc-tid]');
    if (!dato || !tid) return;

    var note = dialog.querySelector('[data-rmc-lukket]');
    var muligheder = Array.prototype.slice.call(tid.options);

    dato.addEventListener('change', function () {
      if (!dato.value) return;

      var d = new Date(dato.value + 'T12:00:00');
      if (isNaN(d.getTime())) return;

      var ugedag = d.getDay();
      var maaned = ('0' + (d.getMonth() + 1)).slice(-2);
      var erSoendag = ugedag === 0;
      var erLukket = false;

      var lukkede = (dialog.getAttribute('data-rmc-soendag-lukket') || '')
        .split(',')
        .map(function (m) { return m.trim(); });

      if (ugedag === 6 && dialog.getAttribute('data-rmc-lukket-loerdag') === '1') {
        erLukket = true;
      }
      if (erSoendag && lukkede.indexOf(maaned) !== -1) {
        erLukket = true;
      }

      if (note) {
        if (erLukket) {
          note.textContent = dialog.getAttribute('data-rmc-lukket-besked') || 'Vi har lukket den dag.';
          note.hidden = false;
        } else {
          note.hidden = true;
        }
      }

      muligheder.forEach(function (o) {
        var vis = true;
        if (erSoendag && o.value) {
          vis = o.getAttribute('data-rmc-soendag') === '1';
        }
        o.disabled = !vis;
        o.hidden = !vis;
      });

      if (tid.selectedIndex > -1 && tid.options[tid.selectedIndex].disabled) {
        tid.selectedIndex = 0;
      }
    });
  }

  function init(dialog) {
    if (dialog.dataset.rmcInit === '1') return;
    dialog.dataset.rmcInit = '1';
    dialoger.push(dialog);

    dialog.querySelectorAll('[data-rmc-bk-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        dialog.close();
      });
    });

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });

    /* i-knappen ved et valg folder forklaringen ud.
       preventDefault er med vilje: knappen staar inde i <label>, og uden den
       kunne klikket risikere ogsaa at vinge selve valget af. */
    dialog.addEventListener('click', function (e) {
      var info = e.target.closest('.rmc-bk-info');
      if (!info || !dialog.contains(info)) return;

      e.preventDefault();
      e.stopPropagation();

      var panel = document.getElementById(info.getAttribute('aria-controls'));
      if (!panel) return;

      var aaben = info.getAttribute('aria-expanded') === 'true';
      info.setAttribute('aria-expanded', aaben ? 'false' : 'true');
      panel.hidden = aaben;
    });

    var krav = dialog.querySelector('[data-rmc-krav]');
    var opgaver = dialog.querySelectorAll('.rmc-bk-opgave > input[type="checkbox"]');

    opgaver.forEach(function (box) {
      box.addEventListener('change', function () {
        if (box.checked && box.dataset.rmcGruppe) {
          opgaver.forEach(function (anden) {
            if (anden !== box && anden.dataset.rmcGruppe === box.dataset.rmcGruppe) {
              anden.checked = false;
              opdaterUnder(anden);
            }
          });
        }
        opdaterUnder(box);
        if (krav && harValg(dialog)) krav.hidden = true;
      });

      opdaterUnder(box);
    });

    datoStyring(dialog);

    var form = dialog.querySelector('form');
    var emneFelt = dialog.querySelector('[data-rmc-emne]');
    var navnFelt = dialog.querySelector('input[name="contact[name]"]');

    if (form) {
      form.addEventListener('submit', function (e) {
        if (dialog.dataset.rmcPaakraevet === '1' && !harValg(dialog)) {
          e.preventDefault();
          if (krav) {
            krav.hidden = false;
            krav.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          }
          return;
        }

        if (emneFelt) {
          var praefiks = emneFelt.dataset.rmcPraefiks || 'Henvendelse';
          var navn = navnFelt ? navnFelt.value.trim() : '';
          emneFelt.value = navn ? praefiks + ' - ' + navn : praefiks;
        }

        try {
          sessionStorage.setItem(NOEGLE, dialog.dataset.rmcAnker || '');
        } catch (err) {}
      });
    }
  }

  /* Efter afsendelse sender Shopify tilbage til siden med ?contact_posted=true.
     Alle dialoger paa siden faar kvitteringen. Vi beholder kun den, der rent
     faktisk blev sendt, og aabner kun den. */
  function kvittering() {
    if (kvitteringVist) return;
    if (window.location.search.indexOf('contact_posted=true') === -1) return;
    if (!dialoger.length) return;
    kvitteringVist = true;

    var sidst = '';
    try {
      sidst = sessionStorage.getItem(NOEGLE) || '';
    } catch (err) {}

    var maal = null;
    if (sidst) {
      for (var i = 0; i < dialoger.length; i++) {
        if (dialoger[i].dataset.rmcAnker === sidst) {
          maal = dialoger[i];
          break;
        }
      }
    }
    if (!maal) maal = dialoger[0];

    dialoger.forEach(function (d) {
      if (d === maal) return;
      var ok = d.querySelector('.rmc-bk-ok');
      if (ok) ok.parentNode.removeChild(ok);
    });

    try {
      sessionStorage.removeItem(NOEGLE);
    } catch (err) {}

    aabn(maal);
  }

  function boot() {
    document.querySelectorAll('dialog.rmc-bk').forEach(init);
    kvittering();
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('a[href], [data-rmc-bk-open]');
    if (!el) return;

    for (var i = 0; i < dialoger.length; i++) {
      var dialog = dialoger[i];
      var anker = dialog.dataset.rmcAnker;
      var traef = false;

      if (el.hasAttribute('data-rmc-bk-open')) {
        traef = el.getAttribute('data-rmc-bk-open') === anker;
      } else if (anker) {
        var href = el.getAttribute('href') || '';
        if (href === '#' + anker || href.slice(-(anker.length + 1)) === '#' + anker) {
          traef = true;
        }
      }

      if (traef) {
        e.preventDefault();
        aabn(dialog);
        return;
      }
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
